import * as z from "zod/v4";

export const updateLinearTicketSla = {
  name: "updateLinearTicketSla" as const,
  input: z.object({
    linearTicketId: z.string(),
    slaBreachesAt: z.string().nullable(),
  }),
  output: z.object({
    success: z.boolean(),
    newSlaBreachesAt: z.string().nullable(),
    error: z.string().nullable().optional(),
  }),
};
